import React from 'react';

export const AddBlue = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 14 14" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M7 1V13" strokeWidth="2" strokeLinecap="round" />
    <path d="M1 7L13 7" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
